import React, { useState, useEffect } from "react";
/* import InscriptionsLibres from "../../components/inscriptionWish/InscriptionsLibres/InscriptionsLibres"; */
import InscriptionsLibres2 from "../../components/inscriptionWish/InscriptionsLibres/InscriptionsLibres2";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getActsDatesDispo } from "../../actions/activites";
import { CircularProgress, Grid, Card } from "@material-ui/core";
import rest from "../../rest";
import { useStyleInscriptionWish } from "./InscriptionWish.css";
import { useSelector } from "react-redux";

const InscriptionWish = (props) => {
  const classesInscriptionWish = useStyleInscriptionWish();
  const [isLoaded, setIsLoaded] = useState(false);
  const [manifInfo, setManifInfo] = useState({});
  const manifParams = useSelector((state) => state.manif);
  /*  const [paramsGeneral, setParamsGeneral] = useState({}); */
  // const [lienLogo, setLienlLogo] = useState("");
  /*   useEffect(() => {
    rest.get("/parametresV2/getGeneral.json").then(function (response) {
      setParamsGeneral(response.data.Parametres);
    });
  }, []); */

  useEffect(() => {
    function load() {
      try {
        // props.getActsDatesDispo();
        // setTimeout(() => {
        //     setIsLoaded(true)
        // }, 1000);
        setIsLoaded(true);
      } catch (e) {
        setIsLoaded(false);
      }
    }
    load();
  }, [isLoaded]);

  useEffect(() => {
    rest.get("/parametres/infoWishlit.json").then((response) => {
      setManifInfo(response.data);
    });
    // eslint-disable-next-line
  }, []);

  return manifParams.manifInfos.StatutInscription === 0 ||
    manifParams.manifInfos.StatutInscription === 1 ? (
    <div className={["App", classesInscriptionWish.bodyContainer]}>
      <Grid container>
        <Grid item xs={12}>
          <Card
            elevation={3}
            className={classesInscriptionWish.card}
            style={{ paddingLeft: 20 }}
          >
            <div
              dangerouslySetInnerHTML={{
                __html:
                  manifParams.manifInfos.StatutInscription === 0
                    ? manifParams.manifInfos.TextInscrFermees
                    : manifParams.manifInfos.StatutInscription === 1
                    ? manifParams.manifInfos.TextInscrAnciens
                    : manifParams.manifInfos.pageAccueilText,
              }}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  ) : (
    <div className={["App", classesInscriptionWish.bodyContainer]}>
      <Grid container>
        {isLoaded ? (
          <Grid item xs={12}>
            <InscriptionsLibres2 manifInfo={manifInfo} />
            {/*  /*  <InscriptionsLibres manifInfo={manifInfo} /> */}
          </Grid>
        ) : (
          <React.Fragment>
            <CircularProgress color="secondary" />
          </React.Fragment>
        )}
      </Grid>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    activites: state.activites,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getActsDatesDispo }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(InscriptionWish);
